import React, { useCallback, useEffect, useMemo, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { getRequest } from 'apis/ApiInstence';
import { toast } from 'react-toastify';

const UpdateRepoter = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const apiBase = useMemo(() => (process.env.REACT_APP_BACKEND_URL || '').replace(/\/+$/, ''), []);
  const backendBase = useMemo(() => (process.env.REACT_APP_BACKEND || '').replace(/\/+$/, ''), []);

  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    mobile: '',
    address: '',
    image: null,
    existingImage: ''
  });

  const fetchRepoter = useCallback(async () => {
    try {
      setFetching(true);
      const response = await getRequest(`repoter/one/${id}`);
      const repoter = response?.data || {};

      setFormData({
        name: repoter.name || '',
        email: repoter.email || '',
        mobile: repoter.mobile || '',
        address: repoter.address || '',
        image: null,
        existingImage: repoter.image ? `${backendBase}/uploads/repoters/${repoter.image}` : ''
      });
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to fetch repoter');
      navigate('/repoters');
    } finally {
      setFetching(false);
    }
  }, [backendBase, id, navigate]);

  useEffect(() => {
    fetchRepoter();
  }, [fetchRepoter]);

  const handleChange = (e) => {
    const { name, type, value, files } = e.target;
    if (type === 'file') {
      setFormData((prev) => ({ ...prev, image: files?.[0] || null }));
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    try {
      setLoading(true);
      const payload = new FormData();
      payload.append('name', formData.name);
      payload.append('email', formData.email);
      payload.append('mobile', formData.mobile);
      payload.append('address', formData.address);
      if (formData.image) payload.append('image', formData.image);

      await axios.patch(`${apiBase}/repoter/${id}`, payload, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      toast.success('Repoter updated successfully');
      navigate('/repoters');
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to update repoter');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="text-white font-weight-bold">Update Repoter</h4>
      </div>

      {fetching ? <p className="mx-4 text-white">Loading...</p> : null}

      {!fetching ? (
        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <div className="row mx-4">
            <div className="col-sm-6 mt-4">
              <label className="adminlables" htmlFor="name">
                Name
              </label>
              <input id="name" name="name" className="form-control" value={formData.name} onChange={handleChange} required />
            </div>

            <div className="col-sm-6 mt-4">
              <label className="adminlables" htmlFor="email">
                Email
              </label>
              <input id="email" type="email" name="email" className="form-control" value={formData.email} onChange={handleChange} required />
            </div>

            <div className="col-sm-6 mt-4">
              <label className="adminlables" htmlFor="mobile">
                Mobile
              </label>
              <input id="mobile" name="mobile" className="form-control" value={formData.mobile} onChange={handleChange} required />
            </div>

            <div className="col-sm-6 mt-4">
              <label className="adminlables" htmlFor="image">
                Image
              </label>
              <input id="image" type="file" name="image" className="form-control filebg" accept="image/*" onChange={handleChange} />
            </div>

            <div className="col-sm-12 mt-4">
              <label className="adminlables" htmlFor="address">
                Address
              </label>
              <textarea id="address" name="address" className="form-control" rows="3" value={formData.address} onChange={handleChange} />
            </div>
          </div>

          <div className="mx-4 mt-3">
            {formData.image ? (
              <img src={URL.createObjectURL(formData.image)} alt="Repoter preview" width={130} className="rounded" />
            ) : formData.existingImage ? (
              <img src={formData.existingImage} alt="Repoter existing" width={130} className="rounded" />
            ) : null}
          </div>

          <div className="mt-5 text-right mx-4">
            <button className="btn btn-lg addbtn" type="submit" disabled={loading}>
              {loading ? 'Updating...' : 'Update Repoter'}
            </button>
          </div>
        </form>
      ) : null}
    </div>
  );
};

export default UpdateRepoter;
